export default __webpack_public_path__ + "static/media/E-WEB-Goal-10.a7817c5e.png";